import siteTab from '@/components/tab'
import { mapGetters } from 'vuex'
export default {
  components: {
    siteTab
  },
  data() {
    return {
      menus: [
        {
          name: 'Email Template',
          href: '/system/manage-email/email-template',
          code: 'SYSTEM.MAIL.TEMPLATE'
        },
        {
          name: 'Actions',
          href: '/system/manage-email/actions',
          code: 'SYSTEM.MAIL.ACTIONS'
        },
        {
          name: 'Email Signature',
          href: '/system/manage-email/email-signature',
          code: 'SYSTEM.MAIL.SIGNATURE'
        },
        {
          name: 'Email Address',
          href: '/system/manage-email/email-address',
          code: 'SYSTEM.MAIL.EMAIL_ADDRESS'
        },
        {
          name: 'Email Checklist',
          href: '/system/manage-email/checklist',
          code: 'SYSTEM.MAIL.CHECKLIST'
        },
        {
          name: 'Records',
          href: '/system/manage-email/records',
          code: 'SYSTEM.MAIL.RECORDS'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    user: {
      handler() {
        this.redict()
      },
      immediate: true
    },
    $route() {
      this.redict()
    }
  },
  methods: {
    redict() {
      if (this.$route.path !== '/system/manage-email') {
        return
      }
      this.menus.some(item => {
        if (this.user.codeList && this.user.codeList.includes(item.code)) {
          this.$router.replace(item.href)
          return true
        }
      })
    }
  }
}
